<template xmlns:v-click-outside="http://www.w3.org/1999/xhtml">
    <div :style="{ top: pin.adjustedY + 'px', left: pin.adjustedX + 'px' }" @click="show"
         class="pin fal"
         :class="pin.type === 'image' ? 'fa-eye' : 'fa-plus'"
         v-click-outside="hide">
        <transition name="fade">
            <div :key="id" v-if="sliderVisible" v-bind:class="dynamicPosition" class="article-slider">
                <transition name="fade">
                    <div class="article-slider-container">
                        <pb-carousel v-if="this.pin.type === 'image'">
                            <a @click="showImage(key)" ref="articleSlider" class="card-deck category-card-deck my-3"
                               :key="image"
                               v-for="(image, key) in pin.imageList">
                                <pb-card class="article-card mx-3" :img-src="image"></pb-card>
                            </a>
                        </pb-carousel>
                        <pb-article-slider v-else :id="id" key="index"
                                           :article-amount="visibleArticleAmount"
                                           :article-list="articleList"
                                           ref="articleSlider"/>
                    </div>
                </transition>
            </div>
        </transition>
        <!---->
        <!--<i v-if="pin.type === 'image'" class="fal fa-eye"></i>-->
        <!--<i  v-else class="fal fa-plus">-->
        <!--</i>-->
        <b-modal @shown="showModal({modal:'single-image'}); modalVisible = true;"
                 @hidden="hideModal({modal:'single-image'}); modalVisible = false;" ok-only size="xl" id="single"
                 ref="single">
            <div ref="carouselContainer">
                <pb-carousel v-if="modalVisible" :loop="true" :initial="selectedImageKey">
                    <div ref="articleSlider"
                         :key="image"
                         v-for="(image) in pin.imageList">
                        <div style="height: 100%; flex: 1 0 0;"
                             :style="{width: $refs.carouselContainer.offsetWidth + 'px'}">
                            <b-img class="single-img m-auto" :src="fileResourceUrl(image)"></b-img>
                        </div>
                    </div>
                </pb-carousel>
            </div>
        </b-modal>
    </div>
</template>

<script>

    import ArticleSlider from "../../components/ui/ArticleSlider";
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'pb-theme-pin',
        components: {
            'pb-article-slider': ArticleSlider
        },
        props: {
            pin: {
                type: Object
            },
            id: {
                type: String
            }
        },
        data: function () {
            return {
                modalVisible: false,
                sliderVisible: false,
                positionClass: null,
                visibleArticleAmount: 3,
                dynamicPosition: null,
                selectedImage: null
            }
        },

        computed: {
            articleList: function () {
                if (this.pin.metaData && this.pin.metaData.articleLabel) {
                    this.pin.articleList.forEach(value => {
                        if (this.pin.metaData.articleLabel[value.id]) {
                            value.description = this.pin.metaData.articleLabel[value.id];
                        }
                    });
                }
                return this.pin.articleList;

            }
        },
        methods: {
            ...mapActions('modal', ['showModal', 'hideModal']),
            showImage(key) {
                this.selectedImageKey = key;
                this.$refs.single.show();
            },
            show() {
                this.sliderVisible = true;
            },
            hide(el) {
                if (!this.$refs.single.isClosing) {
                    this.sliderVisible = false;
                }
            },
            evaluateSliderPosition() {
                this.$nextTick(function () {

                    let imgContainer = this.$el.parentNode.parentNode.parentNode,
                        slider = this.$refs.articleSlider.$el;

                    if (imgContainer && slider) {
                        let viewportExceedingState = this.viewportExceeding(this.$refs.articleSlider.$el, imgContainer);

                        this.dynamicPosition = {
                            top: viewportExceedingState && viewportExceedingState.exceedingBottom,
                            right: viewportExceedingState && viewportExceedingState.exceedingRight,
                            left: viewportExceedingState && viewportExceedingState.exceedingLeft,
                        }
                    }
                });
            }
        },
        watch: {
            sliderVisible: function (newVisibilityState) {
                if (newVisibilityState === true) {
                    this.dynamicPosition = null;
                    this.evaluateSliderPosition();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fal:before {
        line-height: 44px;
        white-space: nowrap;
    }

    .article-slider-container {
        z-index: 1001;
        background: white;
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
    }

    .single-img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .pin {
        cursor: pointer;
        position: absolute;
        width: 45px;
        height: 45px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        box-shadow: 0 2px 30px 0 #4A4B4D;
        text-align: center;
        font-size: 20px;

        .article-slider {
            display: inline-block;
            position: absolute;
            width: auto;
            left: 15px;
            top: 60px;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
            max-width: 1016px;
            z-index: 20;

            &:before {
                bottom: 100%;
                left: 50%;
                content: " ";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border: 8px solid transparent;
                border-bottom-color: white;
            }

            &.top {
                top: -355px;
                margin: auto;

                &:before {
                    bottom: auto;
                    top: 100%;
                    border-bottom-color: transparent;
                    border-top-color: white;
                }
            }

            &.right {
                -moz-transform: translateX(-100%);
                -ms-transform: translateX(-100%);
                -webkit-transform: translateX(-100%);
                -o-transform: translateX(-100%);
                transform: translateX(-100%);
                left: 50px;

                &:before {
                    left: auto;
                    right: 20px;
                }
            }

            &.left {
                -moz-transform: translateX(0);
                -ms-transform: translateX(0);
                -webkit-transform: translateX(0);
                -o-transform: translateX(0);
                transform: translateX(0);
                left: -6px;

                &:before {
                    right: auto;
                    left: 20px;
                }
            }
        }
    }


</style>